import Component from '../inherited/Component'

export default class ReadMore extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._readMoreShow = this._elem.querySelector('[data-read-more-show]')
    this._readMoreHide = this._elem.querySelector('[data-read-more-hide]')
    this._readMoreContent = this._elem.querySelector('[data-read-more-content]')
  }

  mount () {
    
    let readMore = () => {
      if (this._readMoreContent.offsetHeight < this._readMoreContent.scrollHeight ||
          this._readMoreContent.offsetWidth < this._readMoreContent.scrollWidth) {
          this._readMoreShow.classList.remove('hide')
          this._readMoreHide.classList.add('hide')
      } else {
          this._readMoreShow.classList.add('hide')
          this._readMoreHide.classList.remove('hide')
      }
    }

    readMore()
    window.addEventListener('resize', readMore, { passive: true })

    this._readMoreShow.addEventListener('click', e => {
      e.preventDefault()
      this._elem.classList.add('read-more-opened')
      readMore()
    })

    this._readMoreHide.addEventListener('click', e => {
      e.preventDefault()
      this._elem.classList.remove('read-more-opened')
      readMore()
    })

  }
}